import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { ProductTypeEnum } from './model/enums/ProductTypeEnum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  title = 'frontend';
  enLanguageCode = 'en';
  nlLanguageCode = 'nl';

  constructor(
    translate: TranslateService,
    router: Router,
    activatedRoute: ActivatedRoute
  ) {
    translate.setDefaultLang('nl');

    router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(() => activatedRoute),
      map(route => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      mergeMap(route => route.paramMap),
    ).subscribe(paramMap => {

      const productType = paramMap.get('productType') || '';

      if (productType && !this.isValidProductType(productType)) {
        router.navigate(['/']);
      }

      if (paramMap.has('locale')) {
        translate.use(paramMap.get('locale'));
      }
    });
  }

  isValidProductType(productType): boolean {
    return ProductTypeEnum[productType.toUpperCase()];
  }
}
